
<app-header></app-header>

<section style="margin-top:100px">
    <h1 class="center">Offers</h1>
        </section>
        <div class="tab-pane active">
            <div class="container">
                <div class="image-grid">
                    <img *ngFor="let image of imageUrls" [src]="image" alt="Crypto Image">
                </div>
            </div>
        </div>
        
  <section style="margin-top:320px">
    <app-footer></app-footer>
</section>
